import { ColDef, GridApi } from 'ag-grid-community';
import { useRef } from 'react';
import { FundingOrgsRowRenderer } from './funding-orgs-row-renderer.component';
import { GridView } from '@vivli/shared/views';
import { IFundingOrganization } from '@vivli/features/organizations/infrastructure/interface';

interface FundingOrgsGridComponentProps {
    fundingOrgs: IFundingOrganization[];
    handleFunderChange?: (fundingOrganizations: IFundingOrganization[]) => void;
    handleRemoveRow?: (fundingOrganization: IFundingOrganization) => void;
    onGridReady?: (gridApi: GridApi) => void;
    emptyMessage?: string;
    hideFloatingFilter?: boolean;
    hideHeader?: boolean;
    autoHeight?: boolean;
    canEdit?: boolean;
    isListingRequest?: boolean;
}

export const FundingOrgsGridComponent = ({
    fundingOrgs,
    handleFunderChange,
    handleRemoveRow,
    onGridReady,
    emptyMessage,
    hideFloatingFilter,
    hideHeader,
    autoHeight,
    canEdit,
    isListingRequest,
}: FundingOrgsGridComponentProps) => {
    const gridApiRef = useRef<GridApi>();

    const handleOnGridReady = (gridApi: GridApi) => {
        onGridReady && onGridReady(gridApi);
        gridApiRef.current = gridApi;
    };

    const columnDefs: ColDef[] = [
        {
            field: 'fundingOrganization',
            headerName: 'Funding Organization',
            filter: true,
            sortable: true,
            cellRenderer: 'FundingOrgsRow',
            cellRendererParams: {
                onFunderChange: handleFunderChange,
                onRemoveRow: handleRemoveRow,
                canEdit: canEdit,
                baseFormField: isListingRequest ? 'datasets[0]' : null,
            },
        },
    ];

    const customComponents = [
        {
            name: 'FundingOrgsRow',
            component: FundingOrgsRowRenderer,
        },
    ];

    return (
        <GridView
            rowData={fundingOrgs}
            fullWidthColumns={true}
            onGridReady={handleOnGridReady}
            columns={columnDefs}
            emptyMessage={emptyMessage}
            hideFloatingFilter={hideFloatingFilter}
            hideHeader={hideHeader}
            autoHeight={autoHeight}
            customComponents={customComponents}
            rowHeight={100}
            flushPrevious={true}
        />
    );
};
